// import React, { useState, useEffect, useRef } from 'react';
// import { Search, Plus, MoreVertical, Phone, Video, Send, Paperclip, Smile, X, Users, Pin, Trash2, Check, CheckCheck, Image, FileText, Play } from 'lucide-react';
// import Modal from "react-bootstrap/Modal";
// import Dashboardnavbar from '../../layout/Dashboardnavbar';
// import { BASE_URL } from '../../config/axios';

// const WhatsAppChat = () => {
//     const [chats, setChats] = useState([]);
//     const [activeChat, setActiveChat] = useState(null);
//     const [messages, setMessages] = useState([]);
//     const [messageInput, setMessageInput] = useState('');
//     const [showNewChatModal, setShowNewChatModal] = useState(false);
//     const [showGroupModal, setShowGroupModal] = useState(false);
//     const [selectedEmployees, setSelectedEmployees] = useState([]);
//     const [groupName, setGroupName] = useState('');
//     const [searchTerm, setSearchTerm] = useState('');
//     const [showChatMenu, setShowChatMenu] = useState(null);
//     const [showMessageMenu, setShowMessageMenu] = useState(null);
//     const [selectedFile, setSelectedFile] = useState(null);
//     const [onlineUsers, setOnlineUsers] = useState([]);
//     const [typing, setTyping] = useState({});
//     const [employees, setEmployees] = useState([]);
//     const [connectionStatus, setConnectionStatus] = useState('disconnected');
//     const [debugLogs, setDebugLogs] = useState([]);

//     const messagesEndRef = useRef(null);
//     const reconnectAttemptsRef = useRef(0);
//     const fileInputRef = useRef(null);
//     const wsRef = useRef(null);
//     const typingTimeoutRef = useRef(null);
//     const reconnectTimeoutRef = useRef(null);
//     //     const reconnectAttemptsRef = useRef(0);
//     const currentUser = sessionStorage.getItem('emp_code') || 'CIPL10002';
//     const token = sessionStorage.getItem('access_token');

//     const addDebugLog = (message) => {
//         console.log(message);
//         setDebugLogs(prev => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
//     };

//     // WebSocket Connection
//     useEffect(() => {
//         connectWebSocket();
//         loadEmployees();
//         loadChats();

//         return () => {
//             if (wsRef.current) {
//                 wsRef.current.close();
//             }
//         };
//     }, []);

//     useEffect(() => {
//         scrollToBottom();
//     }, [messages]);
//     const testWebSocketEndpoint = async () => {
//         try {
//             const response = await fetch('https://5rn0m63d-8000.inc1.devtunnels.ms/', {
//                 method: 'GET',
//             });
//             console.log('Django server response:', response.status);

//             // Try to connect with a simpler URL
//             const testWs = new WebSocket('ws://localhost:8000/ws/chat/');

//             testWs.onopen = () => {
//                 console.log('✅ Basic WebSocket connection works!');
//                 testWs.close();
//             };

//             testWs.onerror = (error) => {
//                 console.log('❌ Basic WebSocket also fails - Django Channels likely not running');
//             };

//         } catch (error) {
//             console.log('❌ Cannot reach Django server:', error);
//         }
//     };
//     const connectWebSocket = () => {
//         try {
//             if (wsRef.current) {
//                 wsRef.current.close();
//             }

//             addDebugLog('🔄 Connecting to WebSocket...', 'info');
//             setConnectionStatus('connecting');

//             // --- ✅ Smart WebSocket URL selection ---
//             const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

//             // Auto-detect environment: local vs production
//             const wsHost =
//                 window.location.hostname === 'localhost'
//                     ? 'localhost:8000'
//                     : '150.129.248.143'; // your production host/IP

//             // Always include the correct room and token
//             const wsUrl = `${wsProtocol}//${wsHost}/ws/chat/room1/?token=${token}`;

//             addDebugLog(`📡 URL: ${wsUrl}`, 'info');

//             // --- Open connection ---
//             wsRef.current = new WebSocket(wsUrl);

//             wsRef.current.onopen = () => {
//                 addDebugLog('✅ WebSocket Connected!', 'success');
//                 setConnectionStatus('connected');
//                 reconnectAttemptsRef.current = 0;

//                 if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);

//                 sendWebSocketMessage({
//                     type: 'test_connection',
//                     message: 'Client connected',
//                     user: currentUser,
//                 });
//             };

//             wsRef.current.onmessage = (event) => {
//                 try {
//                     const data = JSON.parse(event.data);
//                     addDebugLog(`📨 Received: ${data.type}`, 'receive');
//                     handleWebSocketMessage(data);
//                 } catch (error) {
//                     addDebugLog(`❌ Parse error: ${error.message}`, 'error');
//                 }
//             };

//             wsRef.current.onerror = (error) => {
//                 addDebugLog(`❌ WebSocket Error`, 'error');
//                 setConnectionStatus('error');
//             };

//             wsRef.current.onclose = (event) => {
//                 addDebugLog(`🔌 Disconnected (${event.code})`, 'warning');
//                 setConnectionStatus('disconnected');

//                 // --- Exponential backoff for reconnection ---
//                 reconnectAttemptsRef.current += 1;
//                 const delay = Math.min(1000 * Math.pow(2, reconnectAttemptsRef.current), 30000);

//                 if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);

//                 reconnectTimeoutRef.current = setTimeout(() => {
//                     addDebugLog(`🔄 Reconnecting (attempt ${reconnectAttemptsRef.current})...`, 'info');
//                     connectWebSocket();
//                 }, delay);
//             };
//         } catch (error) {
//             addDebugLog(`❌ Setup error: ${error.message}`, 'error');
//             setConnectionStatus('error');
//         }
//     };

//     const sendWebSocketMessage = (data) => {
//         if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
//             try {
//                 const message = JSON.stringify(data);
//                 wsRef.current.send(message);
//                 addDebugLog(`📤 Sent: ${data.type}`);
//                 console.log('Message sent:', data);
//             } catch (error) {
//                 addDebugLog(`❌ Send error: ${error.message}`);
//                 console.error('Error sending WebSocket message:', error);
//             }
//         } else {
//             const state = wsRef.current ? wsRef.current.readyState : 'no connection';
//             addDebugLog(`❌ Cannot send - WebSocket state: ${getWebSocketState()}`);
//             console.warn('WebSocket not connected. Ready state:', state);
//         }
//     };

//     const getWebSocketState = () => {
//         if (!wsRef.current) return 'NOT_INITIALIZED';
//         const states = {
//             0: 'CONNECTING',
//             1: 'OPEN',
//             2: 'CLOSING',
//             3: 'CLOSED'
//         };
//         return states[wsRef.current.readyState] || 'UNKNOWN';
//     };

//     const scrollToBottom = () => {
//         messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     };

//     const loadEmployees = async () => {
//         try {
//             addDebugLog('Loading employees...');
//             const response = await fetch(`${BASE_URL}/wfm/employees/`, {
//                 headers: { 'Authorization': `Bearer ${token}` }
//             });
//             if (!response.ok) throw new Error(`HTTP ${response.status}`);
//             const data = await response.json();
//             setEmployees(data);
//             addDebugLog(`✅ Loaded ${data.length} employees`);
//         } catch (error) {
//             addDebugLog(`❌ Error loading employees: ${error.message}`);
//             console.error('Error loading employees:', error);
//             // Fallback data
//             setEmployees([
//                 { emp_code: "CIPL10016", name: "Sakshi Devi", email: "sakshisharma1232002@gmail.com", profilepic: "", department: "IT" },
//                 { emp_code: "CIPL10021", name: "Amit Kumar", email: "amitdeveloper160@gmail.com", profilepic: "", department: "IT" },
//                 { emp_code: "CIPL10017", name: "Avin Kundu", email: "avinkundu16@gmail.com", profilepic: "", department: "IT" },
//             ]);
//         }
//     };

//     const loadChats = async () => {
//         try {
//             addDebugLog('Loading chats...');
//             const response = await fetch(`${BASE_URL}/messenger/api/chat/list/`, {
//                 headers: { 'Authorization': `Bearer ${token}` }
//             });
//             if (!response.ok) throw new Error(`HTTP ${response.status}`);
//             const data = await response.json();
//             setChats(data);
//             addDebugLog(`✅ Loaded ${data.length} chats`);
//         } catch (error) {
//             addDebugLog(`❌ Error loading chats: ${error.message}`);
//             console.error('Error loading chats:', error);
//         }
//     };

//     const loadMessages = async (chatId) => {
//         try {
//             addDebugLog(`Loading messages for chat ${chatId}...`);
//             const response = await fetch(`${BASE_URL}/messenger/api/chat/${chatId}/messages/`, {
//                 headers: { 'Authorization': `Bearer ${token}` }
//             });
//             if (!response.ok) throw new Error(`HTTP ${response.status}`);
//             const data = await response.json();
//             setMessages(data);
//             addDebugLog(`✅ Loaded ${data.length} messages`);

//             // Mark messages as read
//             sendWebSocketMessage({
//                 type: 'mark_read',
//                 chat_id: chatId
//             });
//         } catch (error) {
//             addDebugLog(`❌ Error loading messages: ${error.message}`);
//             console.error('Error loading messages:', error);
//         }
//     };

//     // Rest of your functions (handleNewMessage, handleTyping, etc.) remain the same
//     const handleNewMessage = (message) => {
//         if (activeChat && message.chat_id === activeChat.id) {
//             setMessages(prev => [...prev, message]);
//             sendWebSocketMessage({
//                 type: 'mark_read',
//                 chat_id: message.chat_id
//             });
//         }

//         setChats(prev => {
//             const updated = prev.map(chat => {
//                 if (chat.id === message.chat_id) {
//                     return {
//                         ...chat,
//                         last_message: message.content,
//                         last_message_time: message.timestamp,
//                         unread_count: activeChat?.id === message.chat_id ? 0 : (chat.unread_count || 0) + 1
//                     };
//                 }
//                 return chat;
//             });

//             const chatIndex = updated.findIndex(c => c.id === message.chat_id);
//             if (chatIndex > 0) {
//                 const [chat] = updated.splice(chatIndex, 1);
//                 updated.unshift(chat);
//             }

//             return updated;
//         });
//     };

//     const handleWebSocketMessage = (data) => {
//         addDebugLog(`Processing: ${data.type}`);
//         switch (data.type) {
//             case 'new_message':
//                 handleNewMessage(data.message);
//                 break;
//             case 'message_deleted':
//                 // handleMessageDeleted(data.message_id);
//                 break;
//             case 'message_status':
//                 // updateMessageStatus(data.message_id, data.status);
//                 break;
//             case 'typing':
//                 handleTyping(data.chat_id, data.user, data.is_typing);
//                 break;
//             case 'online_users':
//                 setOnlineUsers(data.users);
//                 break;
//             case 'chat_created':
//                 // handleChatCreated(data.chat);
//                 break;
//             case 'connection_established':
//                 addDebugLog('✅ Server acknowledged connection');
//                 break;
//             case 'test_response':
//                 addDebugLog('✅ Test message received from server');
//                 break;
//             default:
//                 addDebugLog(`❓ Unknown message type: ${data.type}`);
//         }
//     };

//     const handleTyping = (chatId, user, isTyping) => {
//         if (activeChat?.id === chatId) {
//             setTyping(prev => ({
//                 ...prev,
//                 [chatId]: isTyping ? user : null
//             }));
//         }
//     };

//     const startNewChat = async (employee) => {
//         addDebugLog(`Starting new chat with ${employee.name}`);
//         sendWebSocketMessage({
//             type: 'create_chat',
//             participants: [employee.emp_code],
//             chat_type: 'individual'
//         });
//         setShowNewChatModal(false);
//     };

//     const createGroup = () => {
//         if (selectedEmployees.length < 2 || !groupName) {
//             addDebugLog('Group creation failed: insufficient members or no group name');
//             alert("Please select at least 2 members and provide a group name");
//             return;
//         }

//         addDebugLog(`Creating group: ${groupName} with ${selectedEmployees.length} members`);

//         sendWebSocketMessage({
//             type: 'create_chat',
//             participants: selectedEmployees,
//             chat_type: 'group',
//             name: groupName
//         });

//         setShowGroupModal(false);
//         setSelectedEmployees([]);
//         setGroupName('');
//     };

//     const sendMessage = async () => {
//         if (!messageInput.trim() && !selectedFile) return;

//         addDebugLog(`Sending message: ${messageInput.substring(0, 50)}...`);

//         if (selectedFile) {
//             // File upload logic
//             const formData = new FormData();
//             formData.append('file', selectedFile);
//             formData.append('chat_id', activeChat.id);

//             try {
//                 const response = await fetch('/api/chat/upload/', {
//                     method: 'POST',
//                     headers: { 'Authorization': `Bearer ${token}` },
//                     body: formData
//                 });
//                 const fileData = await response.json();

//                 sendWebSocketMessage({
//                     type: 'send_message',
//                     chat_id: activeChat.id,
//                     content: messageInput || selectedFile.name,
//                     message_type: selectedFile.type.startsWith('video') ? 'video' : selectedFile.type.startsWith('image') ? 'image' : 'file',
//                     file_url: fileData.url,
//                     file_name: selectedFile.name,
//                     file_size: selectedFile.size
//                 });

//                 setSelectedFile(null);
//             } catch (error) {
//                 addDebugLog(`❌ File upload error: ${error.message}`);
//                 console.error('Error uploading file:', error);
//             }
//         } else {
//             sendWebSocketMessage({
//                 type: 'send_message',
//                 chat_id: activeChat.id,
//                 content: messageInput,
//                 message_type: 'text'
//             });
//         }

//         setMessageInput('');

//         // Stop typing indicator
//         sendWebSocketMessage({
//             type: 'typing',
//             chat_id: activeChat.id,
//             is_typing: false
//         });
//     };

//     const handleTypingInput = (e) => {
//         setMessageInput(e.target.value);

//         sendWebSocketMessage({
//             type: 'typing',
//             chat_id: activeChat.id,
//             is_typing: true
//         });

//         if (typingTimeoutRef.current) {
//             clearTimeout(typingTimeoutRef.current);
//         }

//         typingTimeoutRef.current = setTimeout(() => {
//             sendWebSocketMessage({
//                 type: 'typing',
//                 chat_id: activeChat.id,
//                 is_typing: false
//             });
//         }, 2000);
//     };

//     // Add this to your JSX to see debug logs
//     const DebugPanel = () => (
//         <div style={{
//             position: 'fixed',
//             bottom: '10px',
//             right: '10px',
//             width: '400px',
//             height: '200px',
//             backgroundColor: 'rgba(0,0,0,0.8)',
//             color: 'white',
//             padding: '10px',
//             fontSize: '12px',
//             overflowY: 'auto',
//             zIndex: 1000,
//             border: '1px solid #ccc'
//         }}>
//             <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>WebSocket Debug Logs:</div>
//             {debugLogs.slice(-10).map((log, index) => (
//                 <div key={index} style={{
//                     color: log.includes('✅') ? 'lightgreen' :
//                         log.includes('❌') ? 'red' :
//                             log.includes('❓') ? 'yellow' : 'white',
//                     marginBottom: '2px'
//                 }}>
//                     {log}
//                 </div>
//             ))}
//         </div>
//     );

//     const getConnectionColor = () => {
//         switch (connectionStatus) {
//             case 'connected': return '#00a884';
//             case 'connecting': return '#ffa500';
//             case 'error': return '#ff0000';
//             default: return '#666';
//         }
//     };

//     // const handleTypingInput = (e) => {
//     //     setMessageInput(e.target.value);

//     //     // Send typing indicator
//     //     sendWebSocketMessage({
//     //         type: 'typing',
//     //         chat_id: activeChat.id,
//     //         is_typing: true
//     //     });

//     //     // Clear previous timeout
//     //     if (typingTimeoutRef.current) {
//     //         clearTimeout(typingTimeoutRef.current);
//     //     }

//     //     // Stop typing after 2 seconds
//     //     typingTimeoutRef.current = setTimeout(() => {
//     //         sendWebSocketMessage({
//     //             type: 'typing',
//     //             chat_id: activeChat.id,
//     //             is_typing: false
//     //         });
//     //     }, 2000);
//     // };

//     const pinChat = (chatId) => {
//         sendWebSocketMessage({
//             type: 'pin_chat',
//             chat_id: chatId
//         });
//         setShowChatMenu(null);
//     };

//     const deleteChat = (chatId) => {
//         sendWebSocketMessage({
//             type: 'delete_chat',
//             chat_id: chatId
//         });
//         setShowChatMenu(null);
//     };

//     const clearChat = (chatId) => {
//         sendWebSocketMessage({
//             type: 'clear_chat',
//             chat_id: chatId
//         });
//         setShowChatMenu(null);
//     };

//     const deleteMessage = (messageId, forEveryone = false) => {
//         sendWebSocketMessage({
//             type: 'delete_message',
//             message_id: messageId,
//             for_everyone: forEveryone
//         });
//         setShowMessageMenu(null);
//     };

//     useEffect(() => {
//         testWebSocketEndpoint()
//     }, [])

//     const handleFileSelect = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setSelectedFile(file);
//         }
//     };

//     const filteredChats = chats.filter(chat =>
//         chat.name.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const sortedChats = [...filteredChats].sort((a, b) => {
//         if (a.pinned && !b.pinned) return -1;
//         if (!a.pinned && b.pinned) return 1;
//         return 0;
//     });

//     const getMessageStatus = (message) => {
//         if (message.sender !== currentUser) return null;

//         switch (message.status) {
//             case 'sent':
//                 return <Check className="message-status-icon" size={16} />;
//             case 'delivered':
//                 return <CheckCheck className="message-status-icon" size={16} />;
//             case 'read':
//                 return <CheckCheck className="message-status-icon read" size={16} />;
//             default:
//                 return null;
//         }
//     };

//     const formatTime = (timestamp) => {
//         const date = new Date(timestamp);
//         return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
//     };

//     const isUserOnline = (empCode) => {
//         return onlineUsers.includes(empCode);
//     };

//     return (
//         <div> <Dashboardnavbar name="Messenger" url="messenger" />
//             <div className="content-tabs">  <div className="whatsapp-container">
//                 <style>{`


//         .whatsapp-container {
//           display: flex;
//           height: 100vh;

//           background: #fff;
//         }

//         .sidebar {
//           width: 400px;
//           background: #fff;
//           border-right: 1px solid #2576bc;
//           display: flex;
//           flex-direction: column;
//         }

//         .sidebar-header {
//           background: #fff;
//           padding: 15px;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .sidebar-title {
//           color: #2576bc;
//           font-size: 20px;
//           font-weight: 600;
//         }

//         .header-icons {
//           display: flex;
//           gap: 20px;
//         }

//         .icon-btn {
//           background: none;
//           border: none;
//           color: #aebac1;
//           cursor: pointer;
//           padding: 5px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: color 0.2s;
//         }

//         .icon-btn:hover {
//           color: #2576bc;
//         }

//         .search-box {
//           padding: 10px 15px;
//           background: #fff;
//         }

//         .search-input-wrapper {
//           background: #fff;
//           border-radius: 8px;
//           padding: 8px 12px;
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           border:2px solid #2576bc;

//         }

//         .search-input-wrapper input {
//           background: none;
//           border: none;
//           color: #2576bc;
//           width: 100%;
//           outline: none;
//           font-size: 14px;
//         }

//         .search-input-wrapper input::placeholder {
//           color: black;
//         }

//         .chats-list {
//           flex: 1;
//           overflow-y: auto;
//         }

//         .chat-item {
//           padding: 15px;
//           border-bottom: 1px solid #fff;
//           cursor: pointer;
//           transition: background 0.2s;
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           position: relative;
//         }

//         .chat-item:hover {
//           background: #fff;
//         }

//         .chat-item.active {
//           background: #fff;
//         }



//         .avatar {
//           width: 50px;
//           height: 50px;
//           border-radius: 50%;
//           background: #00a884;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: #fff;
//           font-weight: 600;
//           font-size: 18px;
//           flex-shrink: 0;
//           position: relative;
//         }

//         .avatar img {
//           width: 100%;
//           height: 100%;
//           border-radius: 50%;
//           object-fit: cover;
//         }

//         .online-indicator {
//           width: 12px;
//           height: 12px;
//           background: #00a884;
//           border-radius: 50%;
//           position: absolute;
//           bottom: 2px;
//           right: 2px;
//           border: 2px solid #fff;
//         }

//         .chat-info {
//           flex: 1;
//           min-width: 0;
//         }

//         .chat-header-row {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 4px;
//         }

//         .chat-name {
//           color: #2576bc;
//           font-size: 16px;
//           font-weight: 500;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .chat-time {
//           color: black;
//           font-size: 12px;
//         }

//         .chat-last-message {
//           color: black;
//           font-size: 14px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           display: flex;
//           align-items: center;
//           gap: 5px;
//         }

//         .unread-badge {
//           background: #00a884;
//           color: #fff;
//           border-radius: 12px;
//           padding: 2px 8px;
//           font-size: 12px;
//           font-weight: 600;
//           min-width: 20px;
//           text-align: center;
//         }

//         .pin-icon {
//           color: black;
//           margin-left: 5px;
//         }

//         .chat-area {
//           flex: 1;
//           display: flex;
//           flex-direction: column;
//           background: #fff;
//         }

//         .no-chat {
//           flex: 1;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           color: black;
//         }

//         .no-chat-icon {
//           width: 200px;
//           height: 200px;
//           background: #fff;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 30px;
//         }

//         .chat-header {
//           background: #fff;
//           padding: 15px 20px;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           border-bottom: 1px solid #fff;
//         }

//         .chat-header-left {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//         }

//         .chat-header-info h3 {
//           color: #2576bc;
//           font-size: 16px;
//           font-weight: 500;
//         }

//         .chat-header-info p {
//           color: black;
//           font-size: 13px;
//           margin-top: 2px;
//         }

//         .chat-header-actions {
//           display: flex;
//           gap: 15px;
//         }

//         .messages-area {
//           flex: 1;
//           overflow-y: auto;
//           padding: 20px;

//         }

//         .message {
//           margin-bottom: 12px;
//           display: flex;
//           position: relative;
//         }

//         .message.own {
//           justify-content: flex-end;
//         }

//         .message-bubble {
//           max-width: 65%;
//           padding: 8px 12px;
//           border-radius: 8px;
//           position: relative;
//           word-wrap: break-word;
//         }

//         .message.own .message-bubble {
//           background: #005c4b;
//           color: #2576bc;
//         }

//         .message:not(.own) .message-bubble {
//           background: #fff;
//           color: #2576bc;
//         }

//         .message-content {
//           margin-bottom: 4px;
//         }

//         .message-file {
//           background: rgba(0,0,0,0.3);
//           border-radius: 8px;
//           padding: 10px;
//           margin-bottom: 5px;
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .message-file-icon {
//           width: 40px;
//           height: 40px;
//           background: rgba(255,255,255,0.1);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .message-file-info {
//           flex: 1;
//         }

//         .message-file-name {
//           color: #2576bc;
//           font-size: 14px;
//           margin-bottom: 2px;
//         }

//         .message-file-size {
//           color: black;
//           font-size: 12px;
//         }

//         .message-image, .message-video {
//           border-radius: 8px;
//           max-width: 300px;
//           margin-bottom: 5px;
//           cursor: pointer;
//         }

//         .message-video {
//           position: relative;
//         }

//         .video-play-icon {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           background: rgba(0,0,0,0.6);
//           width: 50px;
//           height: 50px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//         }

//         .message-footer {
//           display: flex;
//           align-items: center;
//           justify-content: flex-end;
//           gap: 5px;
//           font-size: 11px;
//           color: black;
//         }

//         .message-status-icon {
//           color: black;
//         }

//         .message-status-icon.read {
//           color: #53bdeb;
//         }

//         .message-menu-btn {
//           position: absolute;
//           top: 5px;
//           right: 5px;
//           opacity: 0;
//           transition: opacity 0.2s;
//         }

//         .message:hover .message-menu-btn {
//           opacity: 1;
//         }

//         .typing-indicator {
//           padding: 10px 20px;
//           color: #00a884;
//           font-size: 14px;
//           font-style: italic;
//         }

//         .input-area {
//           background: #fff;
//           padding: 10px 15px;
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .file-preview {
//           position: absolute;
//           bottom: 100%;
//           left: 0;
//           right: 0;
//           background: #fff;
//           padding: 15px;
//           border-top: 1px solid #fff;
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .file-preview-info {
//           flex: 1;
//           color: #2576bc;
//         }

//         .file-preview-close {
//           background: none;
//           border: none;
//           color: black;
//           cursor: pointer;
//           padding: 5px;
//         }

//         .message-input {
//           flex: 1;
//           background: #fff;
//           border: none;
//           color: #2576bc;
//           padding: 10px 15px;
//           border-radius: 8px;
//           outline: none;
//           font-size: 15px;
//           resize: none;
//           max-height: 100px;
//         }

//         .message-input::placeholder {
//           color: black;
//         }

//         .send-btn {
//           background: #00a884;
//           border: none;
//           color: #fff;
//           padding: 10px;
//           border-radius: 50%;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: background 0.2s;
//         }

//         .send-btn:hover {
//           background: #06cf9c;
//         }










//         .employee-list {
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//         }

//         .employee-item {
//           padding: 12px;
//           background: #fff;
//           border-radius: 8px;
//           cursor: pointer;
//           transition: background 0.2s;
//           display: flex;
//           align-items: center;
//           gap: 12px;
//         }

//         .employee-item:hover {
//           background: #374952;
//         }

//         .employee-item.selected {
//           background: #005c4b;
//         }

//         .employee-info {
//           flex: 1;
//         }

//         .employee-name {
//           color: #2576bc;
//           font-size: 16px;
//           font-weight: 500;
//         }

//         .employee-dept {
//           color: black;
//           font-size: 13px;
//           margin-top: 2px;
//         }







//         .btn {
//           padding: 10px 24px;
//           border-radius: 8px;
//           border: none;
//           cursor: pointer;
//           font-size: 14px;
//           font-weight: 500;
//           transition: all 0.2s;
//         }

//         .btn-primary {
//           background: #00a884;
//           color: #fff;
//         }

//         .btn-primary:hover {
//           background: #06cf9c;
//         }

//         .btn-primary:disabled {
//           background: #374952;
//           cursor: not-allowed;
//         }

//         .btn-secondary {
//           background: #fff;
//           color: #2576bc;
//         }

//         .btn-secondary:hover {
//           background: #374952;
//         }

//         .context-menu {
//           position: absolute;
//           background: #233138;
//           border-radius: 8px;
//           box-shadow: 0 2px 10px rgba(0,0,0,0.3);
//           z-index: 1000;
//           min-width: 200px;
//           overflow: hidden;
//         }

//         .context-menu-item {
//           padding: 12px 16px;
//           color: #2576bc;
//           cursor: pointer;
//           transition: background 0.2s;
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           font-size: 14px;
//         }

//         .context-menu-item:hover {
//           background: #fff;
//         }

//         .context-menu-item.danger {
//           color: #f15c6d;
//         }

//         .selected-count {
//           color: black;
//           font-size: 14px;
//           margin-top: 10px;
//         }

//         ::-webkit-scrollbar {
//           width: 6px;
//         }

//         ::-webkit-scrollbar-track {
//           background: transparent;
//         }

//         ::-webkit-scrollbar-thumb {
//           background: #374952;
//           border-radius: 3px;
//         }

//         ::-webkit-scrollbar-thumb:hover {
//           background: #4a5c66;
//         }
//       `}</style>
//                 <div style={{
//                     position: 'fixed',
//                     top: '70px',
//                     right: '20px',
//                     padding: '5px 10px',
//                     borderRadius: '4px',
//                     color: 'white',
//                     backgroundColor: getConnectionColor(),
//                     zIndex: 1000,
//                     fontSize: '12px',
//                     fontWeight: 'bold'
//                 }}>
//                     {connectionStatus.toUpperCase()} - {getWebSocketState()}
//                 </div>
//                 {/* Sidebar */}
//                 <div className="sidebar">
//                     <div className="sidebar-header">
//                         <h2 className="sidebar-title">Chats</h2>
//                         <div className="header-icons">
//                             <button className="icon-btn" onClick={() => setShowGroupModal(true)}>
//                                 <Users size={20} />
//                             </button>
//                             <button className="icon-btn" onClick={() => setShowNewChatModal(true)}>
//                                 <Plus size={20} />
//                             </button>
//                         </div>
//                     </div>

//                     <div className="search-box">
//                         <div className="search-input-wrapper">
//                             <Search size={18} color="black" />
//                             <input
//                                 type="text"
//                                 placeholder="Search or start new chat"
//                                 value={searchTerm}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                             />
//                         </div>
//                     </div>

//                     <div className="chats-list">
//                         {sortedChats.map(chat => (
//                             <div
//                                 key={chat.id}
//                                 className={`chat-item ${activeChat?.id === chat.id ? 'active' : ''} ${chat.pinned ? 'pinned' : ''}`}
//                                 onClick={() => {
//                                     setActiveChat(chat);
//                                     loadMessages(chat.id);
//                                 }}
//                             >
//                                 <div className="avatar">
//                                     {chat.avatar ? (
//                                         <img src={chat.avatar} alt={chat.name} />
//                                     ) : (
//                                         chat.name.charAt(0).toUpperCase()
//                                     )}
//                                     {chat.type === 'individual' && isUserOnline(chat.emp_code) && (
//                                         <div className="online-indicator"></div>
//                                     )}
//                                 </div>
//                                 <div className="chat-info">
//                                     <div className="chat-header-row">
//                                         <span className="chat-name">
//                                             {chat.name}
//                                             {chat.pinned && <Pin size={14} className="pin-icon" />}
//                                         </span>
//                                         <span className="chat-time">{chat.last_message_time && formatTime(chat.last_message_time)}</span>
//                                     </div>
//                                     <div className="chat-header-row">
//                                         <div className="chat-last-message">
//                                             {chat.last_message}
//                                         </div>
//                                         {chat.unread_count > 0 && (
//                                             <span className="unread-badge">{chat.unread_count}</span>
//                                         )}
//                                     </div>
//                                 </div>
//                                 <button
//                                     className="icon-btn"
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         setShowChatMenu(showChatMenu === chat.id ? null : chat.id);
//                                     }}
//                                 >
//                                     <MoreVertical size={18} />
//                                 </button>

//                                 {showChatMenu === chat.id && (
//                                     <div className="context-menu" style={{ right: '10px', top: '50px' }}>
//                                         <div className="context-menu-item" onClick={(e) => {
//                                             e.stopPropagation();
//                                             pinChat(chat.id);
//                                         }}>
//                                             <Pin size={18} />
//                                             {chat.pinned ? 'Unpin chat' : 'Pin chat'}
//                                         </div>
//                                         <div className="context-menu-item" onClick={(e) => {
//                                             e.stopPropagation();
//                                             clearChat(chat.id);
//                                         }}>
//                                             <Trash2 size={18} />
//                                             Clear chat
//                                         </div>
//                                         <div className="context-menu-item danger" onClick={(e) => {
//                                             e.stopPropagation();
//                                             deleteChat(chat.id);
//                                         }}>
//                                             <X size={18} />
//                                             Delete chat
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Chat Area */}
//                 <div className="chat-area">
//                     {!activeChat ? (
//                         <div className="no-chat">
//                             <div className="no-chat-icon">
//                                 <Users size={80} color="black" />
//                             </div>
//                             <h2 style={{ color: '#2576bc', marginBottom: '10px' }}>Aimantra Chat</h2>
//                             <p>Select a chat to start messaging</p>
//                         </div>
//                     ) : (
//                         <>
//                             <div className="chat-header">
//                                 <div className="chat-header-left">
//                                     <div className="avatar">
//                                         {activeChat.avatar ? (
//                                             <img src={activeChat.avatar} alt={activeChat.name} />
//                                         ) : (
//                                             activeChat.name.charAt(0).toUpperCase()
//                                         )}
//                                         {activeChat.type === 'individual' && isUserOnline(activeChat.emp_code) && (
//                                             <div className="online-indicator"></div>
//                                         )}
//                                     </div>
//                                     <div className="chat-header-info">
//                                         <h3>{activeChat.name}</h3>
//                                         <p>
//                                             {typing[activeChat.id] ?
//                                                 'typing...' :
//                                                 activeChat.type === 'group' ?
//                                                     `${activeChat.participants?.length || 0} participants` :
//                                                     isUserOnline(activeChat.emp_code) ? 'online' : 'offline'
//                                             }
//                                         </p>
//                                     </div>
//                                 </div>
//                                 <div className="chat-header-actions">
//                                     <button className="icon-btn">
//                                         <Phone size={20} />
//                                     </button>
//                                     <button className="icon-btn">
//                                         <Video size={20} />
//                                     </button>
//                                     <button className="icon-btn">
//                                         <MoreVertical size={20} />
//                                     </button>
//                                 </div>
//                             </div>

//                             <div className="messages-area">
//                                 {messages.map((message) => (
//                                     <div
//                                         key={message.id}
//                                         className={`message ${message.sender === currentUser ? 'own' : ''}`}
//                                     >
//                                         <div className="message-bubble">
//                                             {message.type === 'file' && (
//                                                 <div className="message-file">
//                                                     <div className="message-file-icon">
//                                                         <FileText size={20} />
//                                                     </div>
//                                                     <div className="message-file-info">
//                                                         <div className="message-file-name">{message.file_name}</div>
//                                                         <div className="message-file-size">{(message.file_size / 1024).toFixed(2)} KB</div>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {message.type === 'image' && (
//                                                 <img src={message.file_url} alt="Shared" className="message-image" />
//                                             )}
//                                             {message.type === 'video' && (
//                                                 <div className="message-video">
//                                                     <video src={message.file_url} controls className="message-image" />
//                                                     <div className="video-play-icon">
//                                                         <Play size={24} />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {message.content && (
//                                                 <div className="message-content">{message.content}</div>
//                                             )}
//                                             <div className="message-footer">
//                                                 <span>{formatTime(message.timestamp)}</span>
//                                                 {getMessageStatus(message)}
//                                             </div>
//                                             {message.sender === currentUser && (
//                                                 <button
//                                                     className="icon-btn message-menu-btn"
//                                                     onClick={() => setShowMessageMenu(showMessageMenu === message.id ? null : message.id)}
//                                                 >
//                                                     <MoreVertical size={16} />
//                                                 </button>
//                                             )}
//                                             {showMessageMenu === message.id && (
//                                                 <div className="context-menu" style={{ right: '25px', top: '30px' }}>
//                                                     <div className="context-menu-item" onClick={() => deleteMessage(message.id, false)}>
//                                                         <Trash2 size={18} />
//                                                         Delete for me
//                                                     </div>
//                                                     <div className="context-menu-item danger" onClick={() => deleteMessage(message.id, true)}>
//                                                         <Trash2 size={18} />
//                                                         Delete for everyone
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 ))}
//                                 <div ref={messagesEndRef} />
//                             </div>

//                             {typing[activeChat.id] && (
//                                 <div className="typing-indicator">
//                                     {typing[activeChat.id]} is typing...
//                                 </div>
//                             )}

//                             <div className="input-area" style={{ position: 'relative' }}>
//                                 {selectedFile && (
//                                     <div className="file-preview">
//                                         <div className="file-preview-info">
//                                             <strong>{selectedFile.name}</strong>
//                                             <div style={{ fontSize: '12px', color: 'black' }}>
//                                                 {(selectedFile.size / 1024).toFixed(2)} KB
//                                             </div>
//                                         </div>
//                                         <button className="file-preview-close" onClick={() => setSelectedFile(null)}>
//                                             <X size={20} />
//                                         </button>
//                                     </div>
//                                 )}
//                                 <button className="icon-btn">
//                                     <Smile size={24} />
//                                 </button>
//                                 <button className="icon-btn" onClick={() => fileInputRef.current?.click()}>
//                                     <Paperclip size={24} />
//                                 </button>
//                                 <input
//                                     type="file"
//                                     ref={fileInputRef}
//                                     style={{ display: 'none' }}
//                                     onChange={handleFileSelect}
//                                     accept="image/*,video/*,.pdf,.doc,.docx,.txt"
//                                 />
//                                 <textarea
//                                     className="message-input"
//                                     placeholder="Type a message"
//                                     value={messageInput}
//                                     onChange={handleTypingInput}
//                                     onKeyPress={(e) => {
//                                         if (e.key === 'Enter' && !e.shiftKey) {
//                                             e.preventDefault();
//                                             sendMessage();
//                                         }
//                                     }}
//                                     rows={1}
//                                 />
//                                 <button className="send-btn" onClick={sendMessage}>
//                                     <Send size={20} />
//                                 </button>
//                             </div>
//                         </>
//                     )}
//                 </div>

//                 {/* New Chat Modal */}
//                 {showNewChatModal && (
//                     // <div className="modal-overlay" onClick={() => setShowNewChatModal(false)}>
//                     //     <div className="modal" onClick={(e) => e.stopPropagation()}>
//                     //         <div className="modal-header">
//                     //             <h3 className="modal-title">New Chat</h3>
//                     //             <button className="icon-btn" onClick={() => setShowNewChatModal(false)}>
//                     //                 <X size={24} />
//                     //             </button>
//                     //         </div>
//                     //         <div className="modal-body">
//                     //             <div className="employee-list">
//                     //                 {employees.filter(emp => emp.emp_code !== currentUser).map(employee => (
//                     //                     <div
//                     //                         key={employee.emp_code}
//                     //                         className="employee-item"
//                     //                         onClick={() => startNewChat(employee)}
//                     //                     >
//                     //                         <div className="avatar">
//                     //                             {employee.profilepic ? (
//                     //                                 <img src={employee.profilepic} alt={employee.name} />
//                     //                             ) : (
//                     //                                 employee.name.charAt(0).toUpperCase()
//                     //                             )}
//                     //                         </div>
//                     //                         <div className="employee-info">
//                     //                             <div className="employee-name">{employee.name}</div>
//                     //                             <div className="employee-dept">{employee.department}</div>
//                     //                         </div>
//                     //                     </div>
//                     //                 ))}
//                     //             </div>
//                     //         </div>
//                     //     </div>
//                     // </div>
//                     <Modal
//                         show={showNewChatModal}
//                         onHide={() => setShowNewChatModal(false)}
//                         dialogClassName="request-leave"
//                     >
//                         {/* Header */}
//                         <Modal.Header
//                             closeButton
//                             className="justify-center task-Tab-heading font-weight500 font-size-heading"
//                         >
//                             <Modal.Title>New Chat</Modal.Title>
//                         </Modal.Header>

//                         {/* Body */}
//                         <Modal.Body>
//                             <div className="employee-list">
//                                 {employees
//                                     .filter((emp) => emp.emp_code !== currentUser)
//                                     .map((employee) => (
//                                         <div
//                                             key={employee.emp_code}
//                                             className="employee-item flex-row align-center"
//                                             onClick={() => startNewChat(employee)}
//                                         >
//                                             <div className="avatar">
//                                                 {employee.profilepic ? (
//                                                     <img src={employee.profilepic} alt={employee.name} />
//                                                 ) : (
//                                                     employee.name.charAt(0).toUpperCase()
//                                                 )}
//                                             </div>
//                                             <div className="employee-info">
//                                                 <div className="employee-name">{employee.name}</div>
//                                                 <div className="employee-dept">{employee.department}</div>
//                                             </div>
//                                         </div>
//                                     ))}
//                             </div>
//                         </Modal.Body>
//                     </Modal>
//                 )}

//                 {/* Group Modal */}
//                 {showGroupModal && (
//                     // <div className="modal-overlay" onClick={() => setShowGroupModal(false)}>
//                     //     <div className="modal" onClick={(e) => e.stopPropagation()}>
//                     //         <div className="modal-header">
//                     //             <h3 className="modal-title">Create Group</h3>
//                     //             <button className="icon-btn" onClick={() => setShowGroupModal(false)}>
//                     //                 <X size={24} />
//                     //             </button>
//                     //         </div>
//                     //         <div className="modal-body">
//                     //             <div className="form-group">
//                     //                 <label className="form-label">Group Name</label>
//                     //                 <input
//                     //                     type="text"
//                     //                     className="form-input"
//                     //                     placeholder="Enter group name"
//                     //                     value={groupName}
//                     //                     onChange={(e) => setGroupName(e.target.value)}
//                     //                 />
//                     //             </div>
//                     //             <div className="form-group">
//                     //                 <label className="form-label">Select Members</label>
//                     //                 <div className="selected-count">
//                     //                     {selectedEmployees.length} selected
//                     //                 </div>
//                     //             </div>
//                     //             <div className="employee-list">
//                     //                 {employees.filter(emp => emp.emp_code !== currentUser).map(employee => (
//                     //                     <div
//                     //                         key={employee.emp_code}
//                     //                         className={`employee-item ${selectedEmployees.includes(employee.emp_code) ? 'selected' : ''}`}
//                     //                         onClick={() => {
//                     //                             setSelectedEmployees(prev =>
//                     //                                 prev.includes(employee.emp_code)
//                     //                                     ? prev.filter(e => e !== employee.emp_code)
//                     //                                     : [...prev, employee.emp_code]
//                     //                             );
//                     //                         }}
//                     //                     >
//                     //                         <div className="avatar">
//                     //                             {employee.profilepic ? (
//                     //                                 <img src={employee.profilepic} alt={employee.name} />
//                     //                             ) : (
//                     //                                 employee.name.charAt(0).toUpperCase()
//                     //                             )}
//                     //                         </div>
//                     //                         <div className="employee-info">
//                     //                             <div className="employee-name">{employee.name}</div>
//                     //                             <div className="employee-dept">{employee.department}</div>
//                     //                         </div>
//                     //                     </div>
//                     //                 ))}
//                     //             </div>
//                     //         </div>
//                     //         <div className="modal-footer">
//                     //             <button className="btn btn-secondary" onClick={() => setShowGroupModal(false)}>
//                     //                 Cancel
//                     //             </button>
//                     //             <button
//                     //                 className="btn btn-primary"
//                     //                 onClick={createGroup}
//                     //                 disabled={selectedEmployees.length < 2 || !groupName}
//                     //             >
//                     //                 Create Group
//                     //             </button>
//                     //         </div>
//                     //     </div>
//                     // </div>
//                     <Modal
//                         show={showGroupModal}
//                         onHide={() => setShowGroupModal(false)}
//                         dialogClassName="request-leave"
//                     >
//                         {/* Header */}
//                         <Modal.Header
//                             closeButton
//                             className="justify-center task-Tab-heading font-weight500 font-size-heading"
//                         >
//                             <Modal.Title>Create Group</Modal.Title>
//                         </Modal.Header>

//                         {/* Body */}
//                         <Modal.Body>
//                             {/* Group Name */}
//                             <div className="form-group">
//                                 <label className="form-label">Group Name</label>
//                                 <input
//                                     type="text"
//                                     className="form-input"
//                                     placeholder="Enter group name"
//                                     value={groupName}
//                                     onChange={(e) => setGroupName(e.target.value)}
//                                 />
//                             </div>

//                             {/* Member Selection */}
//                             <div className="form-group">
//                                 <label className="form-label">Select Members</label>
//                                 <div className="selected-count">
//                                     {selectedEmployees.length} selected
//                                 </div>
//                             </div>

//                             {/* Employee List */}
//                             <div className="employee-list">
//                                 {employees
//                                     .filter((emp) => emp.emp_code !== currentUser)
//                                     .map((employee) => (
//                                         <div
//                                             key={employee.emp_code}
//                                             className={`employee-item ${selectedEmployees.includes(employee.emp_code)
//                                                 ? "selected"
//                                                 : ""
//                                                 }`}
//                                             onClick={() => {
//                                                 setSelectedEmployees((prev) =>
//                                                     prev.includes(employee.emp_code)
//                                                         ? prev.filter((e) => e !== employee.emp_code)
//                                                         : [...prev, employee.emp_code]
//                                                 );
//                                             }}
//                                         >
//                                             <div className="avatar">
//                                                 {employee.profilepic ? (
//                                                     <img src={employee.profilepic} alt={employee.name} />
//                                                 ) : (
//                                                     employee.name.charAt(0).toUpperCase()
//                                                 )}
//                                             </div>
//                                             <div className="employee-info">
//                                                 <div className="employee-name">{employee.name}</div>
//                                                 <div className="employee-dept">{employee.department}</div>
//                                             </div>
//                                         </div>
//                                     ))}
//                             </div>
//                         </Modal.Body>

//                         {/* Footer */}
//                         <Modal.Footer>
//                             <button
//                                 className="btn btn-secondary"
//                                 onClick={() => setShowGroupModal(false)}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 className="btn btn-primary"
//                                 onClick={createGroup}
//                                 disabled={selectedEmployees.length < 2 || !groupName}
//                             >
//                                 Create Group
//                             </button>
//                         </Modal.Footer>
//                     </Modal>
//                 )}
//             </div></div>
//         </div>

//     );
// };

// export default WhatsAppChat;




// WhatsAppChat.jsx - COMPLETE COMPONENT

import React, { useState, useEffect, useRef } from 'react';
import { Search, Plus, MoreVertical, Phone, Video, Send, Paperclip, Smile, X, Users, Pin, Trash2, Check, CheckCheck, FileText, Play, Settings, Archive } from 'lucide-react';
import Modal from "react-bootstrap/Modal";
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import { BASE_URL } from '../../config/axios';
// import './WhatsAppChat.css';

const WhatsAppChat = () => {
    // State Management
    const [chats, setChats] = useState([]);
    const [activeChat, setActiveChat] = useState(null);
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState('');
    const [showNewChatModal, setShowNewChatModal] = useState(false);
    const [showGroupModal, setShowGroupModal] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [groupName, setGroupName] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [showChatMenu, setShowChatMenu] = useState(null);
    const [showMessageMenu, setShowMessageMenu] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [typing, setTyping] = useState({});
    const [employees, setEmployees] = useState([]);
    const [connectionStatus, setConnectionStatus] = useState('disconnected');
    const [debugLogs, setDebugLogs] = useState([]);
    const [showDebug, setShowDebug] = useState(true);

    // Refs
    const messagesEndRef = useRef(null);
    const fileInputRef = useRef(null);
    const wsRef = useRef(null);
    const typingTimeoutRef = useRef(null);
    const reconnectTimeoutRef = useRef(null);
    const reconnectAttemptsRef = useRef(0);
    const messageQueueRef = useRef([]); // Queue for messages when WS is disconnected

    // User Info
    const currentUser = sessionStorage.getItem('emp_code') || 'CIPL10002';
    const currentUserName = sessionStorage.getItem('name') || 'User';
    const token = sessionStorage.getItem('access_token');

    // Debug Logger
    const addDebugLog = (message, type = 'info') => {
        const timestamp = new Date().toLocaleTimeString();
        const logEntry = `${timestamp}: ${message}`;
        console.log(logEntry);
        setDebugLogs(prev => [...prev.slice(-30), { message: logEntry, type }]);
    };

    // Initialize - Only load data, don't connect WebSocket
    useEffect(() => {
        loadEmployees();
        loadChats();

        // Cleanup on unmount
        return () => {
            if (reconnectTimeoutRef.current) {
                clearTimeout(reconnectTimeoutRef.current);
            }
            if (wsRef.current) {
                wsRef.current.close();
            }
        };
    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    // Connect WebSocket only when needed
    const connectWebSocket = () => {
        // If already connected or connecting, do nothing
        if (wsRef.current && (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING)) {
            addDebugLog('⚠️ WebSocket already connected/connecting', 'info');
            return;
        }

        try {
            addDebugLog('🔄 Connecting to WebSocket...', 'info');
            setConnectionStatus('connecting');

            const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const wsHost = window.location.hostname === 'localhost'
                ? '192.168.1.128:8001'
                : '150.129.248.143';

            const encodedToken = encodeURIComponent(token);
            const wsUrl = `${wsProtocol}//${wsHost}/ws/chat/room1/?token=${encodedToken}`;

            addDebugLog(`📡 URL: ${wsUrl}`, 'info');

            wsRef.current = new WebSocket(wsUrl);

            wsRef.current.onopen = () => {
                addDebugLog('✅ WebSocket Connected!', 'success');
                setConnectionStatus('connected');
                reconnectAttemptsRef.current = 0;

                if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);

                // Process any queued messages
                processMessageQueue();
            };

            wsRef.current.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    addDebugLog(`📨 Received: ${data.type}`, 'receive');
                    handleWebSocketMessage(data);
                } catch (error) {
                    addDebugLog(`❌ Parse error: ${error.message}`, 'error');
                }
            };

            wsRef.current.onerror = (error) => {
                addDebugLog(`❌ WebSocket Error: ${error}`, 'error');
                setConnectionStatus('error');
            };

            wsRef.current.onclose = (event) => {
                addDebugLog(`🔌 Disconnected (${event.code})`, 'warning');
                setConnectionStatus('disconnected');

                // Only auto-reconnect if there are pending messages
                if (messageQueueRef.current.length > 0) {
                    reconnectAttemptsRef.current += 1;
                    const delay = Math.min(1000 * Math.pow(2, reconnectAttemptsRef.current), 30000);

                    if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);

                    reconnectTimeoutRef.current = setTimeout(() => {
                        addDebugLog(`🔄 Reconnecting (attempt ${reconnectAttemptsRef.current})...`, 'info');
                        connectWebSocket();
                    }, delay);
                }
            };
        } catch (error) {
            addDebugLog(`❌ Setup error: ${error.message}`, 'error');
            setConnectionStatus('error');
        }
    };

    // Disconnect WebSocket when not needed
    const disconnectWebSocket = () => {
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            addDebugLog('🔌 Manually disconnecting WebSocket...', 'info');
            wsRef.current.close(1000, 'Manual disconnect');
        }
    };

    // Process queued messages when connection is established
    const processMessageQueue = () => {
        if (messageQueueRef.current.length > 0 && wsRef.current?.readyState === WebSocket.OPEN) {
            addDebugLog(`📤 Processing ${messageQueueRef.current.length} queued messages...`, 'info');
            messageQueueRef.current.forEach(message => {
                sendWebSocketMessage(message, true); // true = skip queue
            });
            messageQueueRef.current = [];
        }
    };

    // Send WebSocket message with auto-connect
    const sendWebSocketMessage = (data, skipQueue = false) => {
        // If WebSocket is not open, queue the message and connect
        if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
            if (!skipQueue) {
                addDebugLog(`📬 Queuing message (${data.type}) - WebSocket not connected`, 'info');
                messageQueueRef.current.push(data);

                // Connect WebSocket if not already connecting
                if (!wsRef.current || wsRef.current.readyState === WebSocket.CLOSED) {
                    connectWebSocket();
                }
            }
            return false;
        }

        try {
            const messageData = {
                "message": data.message || data.content || "",
                "type": data.type || "chat_message",
                "user": data.user || currentUser,
                "timestamp": new Date().toISOString(),
                ...data
            };

            // Remove undefined values
            Object.keys(messageData).forEach(key => {
                if (messageData[key] === undefined) {
                    delete messageData[key];
                }
            });

            const messageString = JSON.stringify(messageData);
            wsRef.current.send(messageString);

            addDebugLog(`✅ Sent: ${data.type}`, 'success');
            return true;
        } catch (error) {
            addDebugLog(`❌ Send failed: ${error.message}`, 'error');
            return false;
        }
    };

    const getWebSocketState = () => {
        if (!wsRef.current) return 'NOT_INITIALIZED';
        switch (wsRef.current.readyState) {
            case WebSocket.CONNECTING: return 'CONNECTING';
            case WebSocket.OPEN: return 'OPEN';
            case WebSocket.CLOSING: return 'CLOSING';
            case WebSocket.CLOSED: return 'CLOSED';
            default: return 'UNKNOWN';
        }
    };

    // WebSocket Message Handler
    const handleWebSocketMessage = (data) => {
        console.log('🔍 Backend Response:', data);
        addDebugLog(`📨 Received: ${data.type}`, 'receive');

        switch (data.type) {
            case 'connection_established':
                addDebugLog('✅ WebSocket connection established', 'success');
                addDebugLog(`✅ Connected as: ${data.user}`, 'success');
                setConnectionStatus('connected');
                break;

            case 'new_message':
                addDebugLog(`💬 New message from ${data.message.sender_name}`, 'receive');

                if (activeChat && data.message.chat_id === activeChat.id) {
                    setMessages(prev => [...prev, data.message]);
                }

                // Update chats list
                setChats(prev => {
                    const updated = prev.map(chat => {
                        if (chat.id === data.message.chat_id) {
                            return {
                                ...chat,
                                last_message: data.message.content,
                                last_message_time: data.message.timestamp,
                                unread_count: activeChat?.id === data.message.chat_id ? 0 : (chat.unread_count || 0) + 1
                            };
                        }
                        return chat;
                    });

                    // Move updated chat to top
                    const chatIndex = updated.findIndex(c => c.id === data.message.chat_id);
                    if (chatIndex > 0) {
                        const [chat] = updated.splice(chatIndex, 1);
                        updated.unshift(chat);
                    }

                    return updated;
                });
                break;

            case 'typing':
                if (activeChat && data.chat_id === activeChat.id && data.user !== currentUser) {
                    setTyping(prev => ({
                        ...prev,
                        [data.chat_id]: data.is_typing ? data.user_name : null
                    }));

                    // Auto-clear typing indicator
                    if (data.is_typing) {
                        setTimeout(() => {
                            setTyping(prev => ({
                                ...prev,
                                [data.chat_id]: null
                            }));
                        }, 3000);
                    }
                }
                break;

            case 'chat_created':
                addDebugLog(`✅ Chat created: ${data.chat.name}`, 'success');
                setChats(prev => [data.chat, ...prev]);
                setActiveChat(data.chat);
                setMessages([]);
                setShowNewChatModal(false);
                setShowGroupModal(false);
                setSelectedEmployees([]);
                setGroupName('');
                break;

            case 'error':
                addDebugLog(`❌ Error: ${data.message}`, 'error');
                if (data.message.includes('Authentication required')) {
                    // Don't auto-reconnect on auth errors
                    disconnectWebSocket();
                }
                break;

            default:
                addDebugLog(`❓ Unknown type: ${data.type}`, 'warning');
        }
    };

    // Send Message - Auto-connects WebSocket if needed
    const sendMessage = async () => {
        if (!messageInput.trim() && !selectedFile) return;
        if (!activeChat) return;

        if (selectedFile) {
            // File upload via HTTP API
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('chat_id', activeChat.id);

            try {
                addDebugLog('📤 Uploading file...', 'info');
                const response = await fetch(`${BASE_URL}/messenger/api/chat/upload/`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });

                if (!response.ok) throw new Error('Upload failed');

                const fileData = await response.json();

                // Send file message via WebSocket
                sendWebSocketMessage({
                    "type": "chat_message",
                    "chat_id": activeChat.id,
                    "message": messageInput || `Sent a file: ${selectedFile.name}`,
                    "message_type": "file",
                    "file_url": fileData.url,
                    "file_name": selectedFile.name
                });

                setSelectedFile(null);
            } catch (error) {
                addDebugLog(`❌ File upload error: ${error.message}`, 'error');
                alert('Failed to upload file');
            }
        } else {
            // Text message via WebSocket
            sendWebSocketMessage({
                "type": "chat_message",
                "chat_id": activeChat.id,
                "message": messageInput,
                "message_type": "text"
            });
        }

        setMessageInput('');

        // Stop typing indicator
        sendWebSocketMessage({
            "type": "typing",
            "chat_id": activeChat.id,
            "is_typing": false
        });
    };

    // Typing handler - Auto-connects WebSocket if needed
    const handleTypingInput = (e) => {
        setMessageInput(e.target.value);

        if (activeChat) {
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }

            // Send typing started
            sendWebSocketMessage({
                "type": "typing",
                "chat_id": activeChat.id,
                "is_typing": true
            });

            // Set timeout to send typing stopped
            typingTimeoutRef.current = setTimeout(() => {
                sendWebSocketMessage({
                    "type": "typing",
                    "chat_id": activeChat.id,
                    "is_typing": false
                });
            }, 2000);
        }
    };

    // Chat creation functions
    const startNewChat = (employee) => {
        addDebugLog(`➕ Creating chat with ${employee.name}`, 'info');
        sendWebSocketMessage({
            "type": "create_chat",
            "participants": [employee.emp_code],
            "chat_type": "individual",
            "name": employee.name
        });
    };

    const createGroup = () => {
        if (selectedEmployees.length < 2 || !groupName.trim()) {
            alert("Please select at least 2 members and provide a group name");
            return;
        }

        addDebugLog(`👥 Creating group: ${groupName}`, 'info');
        sendWebSocketMessage({
            "type": "create_chat",
            "participants": selectedEmployees,
            "chat_type": "group",
            "name": groupName
        });
    };

    // API Calls
    const loadEmployees = async () => {
        try {
            addDebugLog('📋 Loading employees...', 'info');
            const response = await fetch(`${BASE_URL}/wfm/employees/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const data = await response.json();
            setEmployees(data);
            addDebugLog(`✅ Loaded ${data.length} employees`, 'success');
        } catch (error) {
            addDebugLog(`❌ Employee load failed: ${error.message}`, 'error');
            setEmployees([
                { emp_code: "CIPL10016", name: "Sakshi Devi", email: "sakshisharma1232002@gmail.com", department: "IT" },
                { emp_code: "CIPL10021", name: "Amit Kumar", email: "amitdeveloper160@gmail.com", department: "IT" },
            ]);
        }
    };

    const loadChats = async () => {
        try {
            addDebugLog('💬 Loading chats...', 'info');
            const response = await fetch(`${BASE_URL}/messenger/api/chat/list/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const data = await response.json();
            setChats(data);
            addDebugLog(`✅ Loaded ${data.length} chats`, 'success');
        } catch (error) {
            addDebugLog(`❌ Chat load failed: ${error.message}`, 'error');
        }
    };

    const loadMessages = async (chatId) => {
        try {
            addDebugLog(`📨 Loading messages for chat ${chatId}...`, 'info');
            const response = await fetch(`${BASE_URL}/messenger/api/chat/${chatId}/messages/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const data = await response.json();
            setMessages(data);
            addDebugLog(`✅ Loaded ${data.length} messages`, 'success');
        } catch (error) {
            addDebugLog(`❌ Message load failed: ${error.message}`, 'error');
        }
    };

    // Utility functions
    const pinChat = (chatId) => {
        addDebugLog(`📌 Pinning chat ${chatId}`, 'info');
        sendWebSocketMessage({
            "type": "pin_chat",
            "chat_id": chatId,
            "pinned": true
        });
        setShowChatMenu(null);
    };

    const deleteChat = (chatId) => {
        addDebugLog(`🗑️ Deleting chat ${chatId}`, 'info');
        sendWebSocketMessage({
            "type": "delete_chat",
            "chat_id": chatId
        });
        setShowChatMenu(null);
    };

    const clearChat = (chatId) => {
        addDebugLog(`🧹 Clearing chat ${chatId}`, 'info');
        sendWebSocketMessage({
            "type": "clear_chat",
            "chat_id": chatId
        });
        setShowChatMenu(null);
    };

    const deleteMessage = (messageId, forEveryone = false) => {
        addDebugLog(`🗑️ Deleting message ${messageId}`, 'info');
        sendWebSocketMessage({
            "type": "delete_message",
            "message_id": messageId,
            "for_everyone": forEveryone
        });
        setShowMessageMenu(null);
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 50 * 1024 * 1024) {
                alert('File size should be less than 50MB');
                return;
            }
            setSelectedFile(file);
        }
    };

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const filteredChats = chats.filter(chat =>
        chat.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedChats = [...filteredChats].sort((a, b) => {
        if (a.pinned && !b.pinned) return -1;
        if (!a.pinned && b.pinned) return 1;
        return new Date(b.last_message_time || 0) - new Date(a.last_message_time || 0);
    });

    const getMessageStatus = (message) => {
        if (message.sender !== currentUser) return null;
        switch (message.status) {
            case 'sent': return <Check size={16} />;
            case 'delivered': return <CheckCheck size={16} />;
            case 'read': return <CheckCheck size={16} style={{ color: '#53bdeb' }} />;
            default: return null;
        }
    };

    const formatTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    };

    const isUserOnline = (empCode) => {
        return onlineUsers.includes(empCode);
    };

    const getConnectionColor = () => {
        switch (connectionStatus) {
            case 'connected': return '#00a884';
            case 'connecting': return '#ffa500';
            case 'error': return '#ff0000';
            default: return '#666';
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    // Debug Panel Component
    const DebugPanel = () => (
        showDebug && (
            <div className="debug-panel">
                <div className="debug-header">
                    <span>WebSocket Manager - Queued: {messageQueueRef.current.length}</span>
                    <div>
                        <button onClick={connectWebSocket} className="debug-btn">Connect</button>
                        <button onClick={disconnectWebSocket} className="debug-btn">Disconnect</button>
                        <button onClick={() => {
                            sendWebSocketMessage({
                                "type": "test_message",
                                "message": "Test message",
                                "user": currentUser
                            });
                        }} className="debug-btn">Test Send</button>
                        <button onClick={() => setDebugLogs([])} className="debug-btn">Clear</button>
                        <button onClick={() => setShowDebug(false)} className="debug-btn">Hide</button>
                    </div>
                </div>
                {debugLogs.map((log, index) => (
                    <div key={index} className={`debug-log debug-${log.type}`}>
                        {log.message}
                    </div>
                ))}
            </div>
        )
    );

    return (
        <div>
            {/* <Dashboardnavbar name="Messenger" url="messenger" /> */}

            {/* Connection Status */}
            <div className="connection-status" style={{ backgroundColor: getConnectionColor() }}>
                <div className={`status-dot ${connectionStatus === 'connecting' ? 'pulse' : ''}`} />
                {connectionStatus.toUpperCase()} - {getWebSocketState()} - Queued: {messageQueueRef.current.length}
            </div>

            {/* Toggle Debug Button */}
            {!showDebug && (
                <button className="show-debug-btn" onClick={() => setShowDebug(true)}>
                    Show Debug
                </button>
            )}

            <div className="content-tabs">
                <div className="whatsapp-container">
                    {/* Sidebar */}
                    <div className="sidebar">
                        <div className="sidebar-header">
                            <h2 className="sidebar-title">Chats</h2>
                            <div className="header-icons">
                                <button className="icon-btn" onClick={() => setShowGroupModal(true)} title="New Group">
                                    <Users size={20} />
                                </button>
                                <button className="icon-btn" onClick={() => setShowNewChatModal(true)} title="New Chat">
                                    <Plus size={20} />
                                </button>
                                <button className="icon-btn" title="Settings">
                                    <Settings size={20} />
                                </button>
                            </div>
                        </div>

                        <div className="search-box">
                            <div className="search-input-wrapper">
                                <Search size={18} />
                                <input
                                    type="text"
                                    placeholder="Search or start new chat"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="chats-list">
                            {sortedChats.length === 0 ? (
                                <div className="empty-state">
                                    <Users size={60} />
                                    <p>No chats yet</p>
                                    <small>Click + to start chatting</small>
                                </div>
                            ) : (
                                sortedChats.map(chat => (
                                    <div
                                        key={chat.id}
                                        className={`chat-item ${activeChat?.id === chat.id ? 'active' : ''} ${chat.pinned ? 'pinned' : ''}`}
                                        onClick={() => {
                                            setActiveChat(chat);
                                            loadMessages(chat.id);
                                        }}
                                    >
                                        <div className="avatar">
                                            {chat.avatar ? (
                                                <img src={chat.avatar} alt={chat.name} />
                                            ) : (
                                                chat.name?.charAt(0).toUpperCase()
                                            )}
                                            {chat.type === 'individual' && isUserOnline(chat.emp_code) && (
                                                <div className="online-indicator" />
                                            )}
                                        </div>
                                        <div className="chat-info">
                                            <div className="chat-header-row">
                                                <span className="chat-name">
                                                    {chat.pinned && <Pin size={14} className="pin-icon" />}
                                                    {chat.name}
                                                </span>
                                                <span className="chat-time">{formatTime(chat.last_message_time)}</span>
                                            </div>
                                            <div className="chat-header-row">
                                                <div className="chat-last-message">{chat.last_message}</div>
                                                {chat.unread_count > 0 && (
                                                    <span className="unread-badge">{chat.unread_count}</span>
                                                )}
                                            </div>
                                        </div>
                                        <button
                                            className="icon-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setShowChatMenu(showChatMenu === chat.id ? null : chat.id);
                                            }}
                                        >
                                            <MoreVertical size={18} />
                                        </button>

                                        {showChatMenu === chat.id && (
                                            <div className="context-menu">
                                                <div className="context-menu-item" onClick={(e) => {
                                                    e.stopPropagation();
                                                    pinChat(chat.id);
                                                }}>
                                                    <Pin size={18} />
                                                    {chat.pinned ? 'Unpin' : 'Pin'}
                                                </div>
                                                <div className="context-menu-item" onClick={(e) => {
                                                    e.stopPropagation();
                                                    clearChat(chat.id);
                                                }}>
                                                    <Archive size={18} />
                                                    Clear chat
                                                </div>
                                                <div className="context-menu-item danger" onClick={(e) => {
                                                    e.stopPropagation();
                                                    deleteChat(chat.id);
                                                }}>
                                                    <Trash2 size={18} />
                                                    Delete
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>

                    {/* Chat Area */}
                    <div className="chat-area">
                        {!activeChat ? (
                            <div className="no-chat">
                                <div className="no-chat-icon">
                                    <Users size={80} />
                                </div>
                                <h2>Aimantra Chat</h2>
                                <p>Select a chat to start messaging</p>
                            </div>
                        ) : (
                            <>
                                <div className="chat-header">
                                    <div className="chat-header-left">
                                        <div className="avatar">
                                            {activeChat.avatar ? (
                                                <img src={activeChat.avatar} alt={activeChat.name} />
                                            ) : (
                                                activeChat.name?.charAt(0).toUpperCase()
                                            )}
                                            {activeChat.type === 'individual' && isUserOnline(activeChat.emp_code) && (
                                                <div className="online-indicator" />
                                            )}
                                        </div>
                                        <div className="chat-header-info">
                                            <h3>{activeChat.name}</h3>
                                            <p className={typing[activeChat.id] ? 'typing' : ''}>
                                                {typing[activeChat.id] ?
                                                    'typing...' :
                                                    activeChat.type === 'group' ?
                                                        `${activeChat.participants?.length || 0} participants` :
                                                        isUserOnline(activeChat.emp_code) ? 'online' : 'offline'
                                                }
                                            </p>
                                        </div>
                                    </div>
                                    <div className="chat-header-actions">
                                        <button className="icon-btn"><Phone size={20} /></button>
                                        <button className="icon-btn"><Video size={20} /></button>
                                        <button className="icon-btn"><MoreVertical size={20} /></button>
                                    </div>
                                </div>

                                <div className="messages-area">
                                    {messages.length === 0 ? (
                                        <div className="empty-state">
                                            <Send size={60} />
                                            <p>No messages yet</p>
                                            <small>Start the conversation</small>
                                        </div>
                                    ) : (
                                        messages.map((message) => (
                                            <div
                                                key={message.id}
                                                className={`message ${message.sender === currentUser ? 'own' : ''}`}
                                            >
                                                <div className="message-bubble">
                                                    {message.sender !== currentUser && activeChat.type === 'group' && (
                                                        <div className="message-sender">{message.sender_name}</div>
                                                    )}

                                                    {message.type === 'file' && (
                                                        <div className="message-file">
                                                            <div className="message-file-icon">
                                                                <FileText size={20} />
                                                            </div>
                                                            <div className="message-file-info">
                                                                <div className="message-file-name">{message.file_name}</div>
                                                                <div className="message-file-size">{formatFileSize(message.file_size)}</div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {message.type === 'image' && (
                                                        <img src={message.file_url} alt="Shared" className="message-image" />
                                                    )}

                                                    {message.type === 'video' && (
                                                        <div className="message-video">
                                                            <video src={message.file_url} controls className="message-image" />
                                                            <div className="video-play-icon">
                                                                <Play size={24} />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {message.content && (
                                                        <div className="message-content">{message.content}</div>
                                                    )}

                                                    <div className="message-footer">
                                                        <span>{formatTime(message.timestamp)}</span>
                                                        {getMessageStatus(message)}
                                                    </div>

                                                    {message.sender === currentUser && (
                                                        <button
                                                            className="icon-btn message-menu-btn"
                                                            onClick={() => setShowMessageMenu(showMessageMenu === message.id ? null : message.id)}
                                                        >
                                                            <MoreVertical size={16} />
                                                        </button>
                                                    )}

                                                    {showMessageMenu === message.id && (
                                                        <div className="context-menu message-context">
                                                            <div className="context-menu-item" onClick={() => deleteMessage(message.id, false)}>
                                                                <Trash2 size={18} />
                                                                Delete for me
                                                            </div>
                                                            <div className="context-menu-item danger" onClick={() => deleteMessage(message.id, true)}>
                                                                <Trash2 size={18} />
                                                                Delete for everyone
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    )}
                                    <div ref={messagesEndRef} />
                                </div>

                                {typing[activeChat.id] && (
                                    <div className="typing-indicator">
                                        {typing[activeChat.id]} is typing...
                                    </div>
                                )}

                                <div className="input-area">
                                    {selectedFile && (
                                        <div className="file-preview">
                                            <div className="file-preview-icon">
                                                <FileText size={24} />
                                            </div>
                                            <div className="file-preview-info">
                                                <div className="file-preview-name">{selectedFile.name}</div>
                                                <div className="file-preview-size">{formatFileSize(selectedFile.size)}</div>
                                            </div>
                                            <button className="file-preview-close" onClick={() => setSelectedFile(null)}>
                                                <X size={20} />
                                            </button>
                                        </div>
                                    )}
                                    <button className="icon-btn" title="Emoji">
                                        <Smile size={24} />
                                    </button>
                                    <button className="icon-btn" onClick={() => fileInputRef.current?.click()} title="Attach">
                                        <Paperclip size={24} />
                                    </button>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleFileSelect}
                                        accept="image/*,video/*,.pdf,.doc,.docx,.txt"
                                    />
                                    <textarea
                                        className="message-input"
                                        placeholder="Type a message"
                                        value={messageInput}
                                        onChange={handleTypingInput}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                e.preventDefault();
                                                sendMessage();
                                            }
                                        }}
                                        rows={1}
                                    />
                                    <button className="send-btn" onClick={sendMessage}>
                                        <Send size={20} />
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Modals */}
            <Modal show={showNewChatModal} onHide={() => setShowNewChatModal(false)} dialogClassName="chat-modal">
                <Modal.Header closeButton>
                    <Modal.Title>New Chat</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="employee-list">
                        {employees
                            .filter((emp) => emp.emp_code !== currentUser)
                            .map((employee) => (
                                <div
                                    key={employee.emp_code}
                                    className="employee-item"
                                    onClick={() => startNewChat(employee)}
                                >
                                    <div className="avatar">
                                        {employee.profilepic ? (
                                            <img src={employee.profilepic} alt={employee.name} />
                                        ) : (
                                            employee.name.charAt(0).toUpperCase()
                                        )}
                                        {isUserOnline(employee.emp_code) && (
                                            <div className="online-indicator" />
                                        )}
                                    </div>
                                    <div className="employee-info">
                                        <div className="employee-name">{employee.name}</div>
                                        <div className="employee-dept">{employee.department}</div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showGroupModal} onHide={() => setShowGroupModal(false)} dialogClassName="chat-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Create Group</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label className="form-label">Group Name</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Enter group name"
                            value={groupName}
                            onChange={(e) => setGroupName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Select Members</label>
                        {selectedEmployees.length > 0 && (
                            <div className="selected-count">
                                {selectedEmployees.length} member{selectedEmployees.length > 1 ? 's' : ''} selected
                            </div>
                        )}
                    </div>
                    <div className="employee-list">
                        {employees
                            .filter((emp) => emp.emp_code !== currentUser)
                            .map((employee) => (
                                <div
                                    key={employee.emp_code}
                                    className={`employee-item ${selectedEmployees.includes(employee.emp_code) ? 'selected' : ''}`}
                                    onClick={() => {
                                        setSelectedEmployees((prev) =>
                                            prev.includes(employee.emp_code)
                                                ? prev.filter((e) => e !== employee.emp_code)
                                                : [...prev, employee.emp_code]
                                        );
                                    }}
                                >
                                    <div className="avatar">
                                        {employee.profilepic ? (
                                            <img src={employee.profilepic} alt={employee.name} />
                                        ) : (
                                            employee.name.charAt(0).toUpperCase()
                                        )}
                                    </div>
                                    <div className="employee-info">
                                        <div className="employee-name">{employee.name}</div>
                                        <div className="employee-dept">{employee.department}</div>
                                    </div>
                                    {selectedEmployees.includes(employee.emp_code) && (
                                        <Check size={20} style={{ color: '#00a884' }} />
                                    )}
                                </div>
                            ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowGroupModal(false)}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={createGroup}
                        disabled={selectedEmployees.length < 2 || !groupName.trim()}
                    >
                        Create Group
                    </button>
                </Modal.Footer>
            </Modal>

            <DebugPanel />
        </div>
    );
};

export default WhatsAppChat;

